import { APP_DEFAULTS } from '@app/constants/app-defaults';
import { EnvModeType } from '@app/enums/env-mode-type.enum';
import { environment } from '@env/environment';

export const APP_STORE_INITIAL_STATE: AppStoreState = {
    isBusy: false,
    titlePage: '',
    languageSelected: 'en-US',
    i18n: APP_DEFAULTS.i18n,
    tkn: '',
    isVendorUser: false,
    isMF: environment.mode !== EnvModeType.LOCAL,
    locationHistory: {
        prevUrl: '',
        currentUrl: '',
    },
    prevInspectionPage: '',
    idleCountDown: 0,
};
export interface AppStoreState {
    isBusy: boolean;
    titlePage: string;
    languageSelected: string;
    i18n: typeof APP_DEFAULTS.i18n;
    tkn: string | null;
    isVendorUser: boolean;
    isMF: boolean;
    locationHistory: LocationHistory;
    prevInspectionPage: string;
    idleCountDown: number;
}
export interface LocationHistory {
    prevUrl: string;
    currentUrl: string;
}
